import React from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export const Switch: React.FC<SwitchProps> = ({ checked, onChange, label, disabled = false }) => {
  return (
    <label className={`inline-flex items-center ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
      {label && <span className="mr-3 text-sm text-gray-700">{label}</span>}
      <div className="relative w-14 h-7">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={() => onChange(!checked)}
          disabled={disabled}
        />
        {/* Circle outline */}
        <span
          className={`
            absolute left-0 top-0 w-7 h-7 rounded-full border
            ${checked ? 'border-purple-600' : 'border-gray-300'}
            ${disabled ? 'opacity-50' : ''}
            transition duration-200
          `}
        />
        
        {/* Toggle circle */}
        <span
          className={`
            absolute top-0 w-7 h-7 rounded-full
            ${checked ? 'right-0 bg-purple-600' : 'left-0 bg-transparent'}
            transition-all duration-200
          `}
        />
      </div>
    </label>
  );
}; 